module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/result_success-f6aef3cc73153a17f246927173cd84a9.svg";